import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export const Link = ({
  size = 14,
  title = 'Link',
  fill = colors.silverSand,
  className = '',
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 11 11"
      className={className}
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={
          'M4.49,2.91l.09-.11,2-2A2.53,2.53,0,0,1,8.5,0,2.55,2.55,0,0,1,11,2.28a2.43,2.43,0,0,1-' +
          '.71,2.06c-.84.87-1.7,1.72-2.56,2.57a2.58,2.58,0,0,1-3.06.41,2.35,2.35,0,0,1-.32-.23.5' +
          '3.53,0,0,1-.18-.6.82.82,0,0,1,1-.66.75.75,0,0,1,.24.08,1.05,1.05,0,0,0,1.37-.23l2.4-2' +
          '.4A1,1,0,0,0,7.79,1.81s0,0,0,.05L6.49,3.11a.17.17,0,0,1-.21,0A3.06,3.06,0,0,0,4.49,2.91Z'
        }
        fill={fill}
      />
      <path
        d={
          'M6.39,8.23l-.08.09L4.39,10.25A2.56,2.56,0,0,1,.21,9.39a2.41,2.41,0,0,1,.51-2.7C1.52,5' +
          '.83,2.37,5,3.21,4.18A2.58,2.58,0,0,1,6.38,3.9a.69.69,0,0,1,.31.93.68.68,0,0,1-.22.26.' +
          '73.73,0,0,1-.93.14,1,1,0,0,0-.81-.13,1.31,1.31,0,0,0-.49.27L1.88,7.73a1,1,0,0,0,0,1.4' +
          'h0a1,1,0,0,0,1.39,0h0C3.66,8.78,4,8.4,4.4,8c0,0,.08-.09.17,0A3.25,3.25,0,0,0,6.39,8.23Z'
        }
        fill={fill}
      />
    </svg>
  );
};
